module.exports = __webpack_public_path__ + "static/media/log-file3.a8b3ecc4.svg";